import { render, staticRenderFns } from "./ModalCadastroDocumento.vue?vue&type=template&id=1ded9706"
import script from "./ModalCadastroDocumento.vue?vue&type=script&lang=js"
export * from "./ModalCadastroDocumento.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports